const getOrdenNameLetters = (str) => {
	if (!str || typeof str !== "string") {
		return "";
	}

	return str.length > 5 ? "-" + str.substring(0, 5) : "-" + str;
};

export default getOrdenNameLetters;
